// extracted by mini-css-extract-plugin
export default {"imageWrapper":"kH-z","videoWrapper":"lH-z","twoColumnImage":"mH-z","imageCarouselBtn":"nH-z","carouselNextBtn":"oH-z","carouselPrevBtn":"pH-z"};